var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42188 9.09029V24.6714C2.42188 25.8399 3.3691 26.7871 4.53756 26.7871H16.1738H25.8037H27.81C28.9785 26.7871 29.9257 25.8399 29.9257 24.6714V16.8808V12.1646C29.9257 10.9962 28.9785 10.049 27.81 10.049H16.1738H12.4816C11.6326 10.049 10.9444 9.36074 10.9444 8.51178C10.9444 7.66283 10.2562 6.97461 9.40721 6.97461H4.53756C3.3691 6.97461 2.42188 7.92183 2.42188 9.09029Z",
    fill: "url(#paint0_linear_1197_11049)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1877 17.3771C22.9379 15.7781 22.2002 14.4585 20.9753 13.4213C19.6877 12.3094 18.1187 11.7529 16.2687 11.7529C14.4182 11.7529 12.8493 12.3031 11.5623 13.4021C10.3369 14.4531 9.60571 15.7781 9.36848 17.3771C9.31821 17.6399 9.29297 17.8898 9.29297 18.1278C9.29297 19.1779 9.63661 20.0962 10.3247 20.8841C11.0119 21.6715 11.9809 22.2473 13.2315 22.6087V22.8912C13.2315 23.2407 13.35 23.5347 13.5875 23.7719C13.8247 24.0097 14.1186 24.1412 14.4687 24.1659C14.8312 24.1913 15.0996 24.1285 15.2748 23.9786C15.5496 24.1781 15.856 24.2781 16.1938 24.2781C16.5063 24.2781 16.7941 24.1847 17.0562 23.9972C17.2314 24.1343 17.4874 24.1913 17.8253 24.1659C18.175 24.1285 18.4691 23.9941 18.7064 23.763C18.9438 23.5306 19.0625 23.2408 19.0625 22.8912V22.6851C20.4124 22.3346 21.4564 21.7473 22.1943 20.9213C22.9068 20.1343 23.263 19.2033 23.263 18.1278C23.263 17.8898 23.2378 17.6399 23.1877 17.3771ZM14.6562 19.187C14.281 19.6188 13.8306 19.8338 13.3061 19.8338C12.7811 19.8338 12.331 19.6188 11.956 19.187C11.581 18.7558 11.3933 18.2334 11.3933 17.6209C11.3933 17.0088 11.581 16.4866 11.956 16.0562C12.331 15.6251 12.7811 15.4095 13.3061 15.4095C13.8306 15.4095 14.281 15.6251 14.6562 16.0562C15.0314 16.4866 15.2193 17.0088 15.2193 17.6209C15.2192 18.2334 15.0314 18.7557 14.6562 19.187ZM16.2872 21.6715C15.9747 21.6715 15.7434 21.5911 15.5937 21.4309C15.506 21.3309 15.4626 21.2079 15.4626 21.0591C15.4626 20.8248 15.5531 20.59 15.7344 20.3545C15.9155 20.1203 16.0934 20.0028 16.2687 20.0028C16.4438 20.0028 16.6089 20.1323 16.7654 20.3931C16.9216 20.6524 17.0004 20.8991 17.0004 21.1345C17.0004 21.4931 16.7624 21.6715 16.2872 21.6715ZM20.4221 19.187C20.0532 19.6188 19.6003 19.8338 19.0624 19.8338C18.5377 19.8338 18.0909 19.6188 17.7221 19.187C17.3529 18.7558 17.1685 18.2334 17.1685 17.6209C17.1685 17.0088 17.3529 16.4866 17.7221 16.0562C18.0909 15.6251 18.5377 15.4095 19.0624 15.4095C19.6003 15.4095 20.0534 15.6251 20.4221 16.0562C20.7906 16.4866 20.9753 17.0088 20.9753 17.6209C20.9754 18.2334 20.7906 18.7557 20.4221 19.187Z",
    fill: "url(#paint1_linear_1197_11049)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0344 27.9829C27.0344 27.9829 31.68 25.66 31.68 22.1758V18.1108L27.0344 16.3687L22.3887 18.1108V22.1758C22.3887 25.66 27.0344 27.9829 27.0344 27.9829Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0344 27.9829C27.0344 27.9829 31.68 25.66 31.68 22.1758V18.1108L27.0344 16.3687L22.3887 18.1108V22.1758C22.3887 25.66 27.0344 27.9829 27.0344 27.9829Z",
    fill: "url(#paint2_linear_1197_11049)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4629 21.3217L26.5125 23.3713L29.9284 19.9553",
    stroke: "white",
    strokeWidth: 1.02478,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_11049",
    x1: 9.32024,
    y1: 9.78636,
    x2: 31.6534,
    y2: 28.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#799DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAFBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_11049",
    x1: 16.278,
    y1: 11.7529,
    x2: 16.278,
    y2: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1197_11049",
    x1: 27.0344,
    y1: 16.3687,
    x2: 27.0344,
    y2: 27.9829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon13);
export default __webpack_public_path__ + "static/media/drive_card_icon13.91e0dbe8007cbad12b710261e2d46500.svg";
export { ForwardRef as ReactComponent };